import { render, staticRenderFns } from "./InscriptionTable.vue?vue&type=template&id=31ef45e1&scoped=true"
import script from "./InscriptionTable.vue?vue&type=script&lang=js"
export * from "./InscriptionTable.vue?vue&type=script&lang=js"
import style0 from "./InscriptionTable.vue?vue&type=style&index=0&id=31ef45e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef45e1",
  null
  
)

export default component.exports